import styled from "@emotion/styled";
import { Modal, ModalActions, modalClasses } from "@kaltura/ds-react-components";

export const StyledModal = styled(Modal)(({ theme }) => ({
    [`& .${modalClasses.paper}`]: {
        display: "flex",
        flexDirection: "column",
        maxHeight: "85vh",
        width: 1200,
        maxWidth: "85vw",
        [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
            width: 800,
            maxWidth: 800,
        },
        [theme.breakpoints.down(theme.breakpoints.values.md)]: {
            width: 552,
            maxWidth: 552,
        },
        [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
            maxHeight: "100vh",
            width: "100%",
        },
    },
}));

export const StyledModalActions = styled(ModalActions)({
    display: "flex",
    justifyContent: "space-between",
});

export const StyledActionButtonsContainer = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
}));
